import React, { useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import "swiper/css";
import { LocatorSwiperContainer } from "../../styled/shop";
import { GoChevronRight } from "react-icons/go";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { useRegex } from "../../../../../hooks/useRegex";
import moment from "moment/moment";

const SlideContent = ({ imgSrc, info, item, clickEvent }) => {
  return (
    <div className="slideContent" onClick={() => clickEvent && clickEvent(item)}>
      <div className="imageArea">
        <img src={imgSrc} onError={(e) => (e.target.src = "/img/shop_network.png")} />
      </div>
      <div className="infoArea">{info}</div>
    </div>
  );
};

const ShopLocatorSwiper = ({ type, swiperRef = null, data = [], clickEvent = null }) => {
  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const { TelFormat } = useRegex();

  const isComponentType = (arr) => {
    if (type === "restaurant") return arr[0];
    if (type === "store") return arr[1];
    if (type === "group") return arr[2];
  };

  const modules = [...isComponentType([[Autoplay], [], []])];

  const renderInfo = (item) => {
    return isComponentType([
      <>
        <div className="tit">{item.cmpnyNm}</div>
        <span>{item.adres || "-"}</span>
        <span>전화번호: {TelFormat(item.telNo)}</span>
      </>,
      <>
        <div className="tit">{item.cmpnyNm}</div>
        <span>{item.logoText ? item.logoText : item.cmpnyNm}</span>
      </>,
      <>
        <div className="tit">
          <div className="grpName">
            <span>{item.groupName}</span>
            <button>
              <GoChevronRight />
            </button>
          </div>
        </div>
        <span className="grpDesc">{moment(item.createDt).format("YYYY.MM.DD")}</span>
      </>,
    ]);
  };

  const isSwiperButton = () => {
    return type === "store" && !isMobile && !isTablet;
  };

  const handleSwiperButton = (isPrev) => {
    if (swiperRef.current) {
      if (isPrev) {
        swiperRef.current.swiper.slidePrev();
      } else {
        swiperRef.current.swiper.slideNext();
      }
    }
  };

  const half = Math.floor(data.length / 2);
  const firstHalf = data.slice(0, half);
  const secondHalf = data.slice(half);

  return (
    <LocatorSwiperContainer>
      {isSwiperButton() && (
        <button className="swiperButons prev" onClick={() => handleSwiperButton(true)}>
          <FaChevronLeft />
        </button>
      )}

      <Swiper
        key={type}
        loop={true}
        ref={swiperRef}
        modules={modules}
        autoplay={{ delay: isComponentType([0, 1000, 1000]), disableOnInteraction: false }}
        spaceBetween={isComponentType([20, 20, 20])}
        className={`mySwiper ${type}`}
        slidesPerView={isComponentType([7, 1, 1])}
        pagination={{ clickable: true }}
        speed={isComponentType([6000, 500, 500])}
        centeredSlides={false}
        breakpoints={{
          0: { slidesPerView: isComponentType([1.5, 2, 1]) },
          767: { slidesPerView: isComponentType([5, 4, 2]) },
          1050: { slidesPerView: isComponentType([7, 5, 3.2]) },
        }}>
        {type === "store"
          ? firstHalf.map((item, index) => (
              <SwiperSlide key={`shop_${type}_${index}`}>
                <SlideContent
                  item={item}
                  imgSrc={imgHandler(JSON.parse(item.bannerImgList))}
                  info={renderInfo(item)}
                  clickEvent={clickEvent}
                />
                {secondHalf[index] && (
                  <SlideContent
                    item={item}
                    imgSrc={imgHandler(JSON.parse(secondHalf[index].bannerImgList))}
                    info={renderInfo(secondHalf[index])}
                    clickEvent={clickEvent}
                  />
                )}
              </SwiperSlide>
            ))
          : data.map((item, index) => (
              <SwiperSlide key={`shop_${type}_${index}`}>
                <SlideContent
                  item={item}
                  imgSrc={imgHandler(item.logoImage ? item.logoImage : item.imgUrl)}
                  info={renderInfo(item)}
                  clickEvent={clickEvent}
                />
              </SwiperSlide>
            ))}
      </Swiper>

      {isSwiperButton() && (
        <button className="swiperButons next" onClick={() => handleSwiperButton(false)}>
          <FaChevronRight />
        </button>
      )}
    </LocatorSwiperContainer>
  );
};

export default ShopLocatorSwiper;
